import React from 'react';
import Logo from '../res/img/logo.svg';
import DarkLogo from '../res/img/darkLogo.png';
import { websiteURL } from '../constants';

const LogoComponent = ({ isDarkMode }) => {

    function redirectHome() {
        window.location.href = websiteURL;
    }

    return <img alt='logo'    style={{ width: "290px", objectFit: "cover"  }}  src={isDarkMode === "true" ? DarkLogo : Logo} className="mr-3" onClick={redirectHome} />;
};

export default LogoComponent;
